<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;height: 100vh;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 10%">
                            <CCol sm="12" style="width: 50%;background-size: cover; margin: auto;">
                                <CCard class="border-radius-16px p-4 mb-5">
                                    <div class="text-center">
                                        <h3 class="custom-32px-500 text-center font-color-171717">Forgot Password </h3>
                                        <p class="custom-16px-400">Enter your email and we'll send you instructions to reset your password</p>
                                    </div>
                                    <div class="mt-3">
                                        <strong class="text-left mt-2 mb-2">Email</strong>
                                        <input type="text" class="custom-input-app mb-2" v-model="userEmail" />
                                    </div>
                                    <div style="clear:both"></div>
                                    <div class="text-center mt-5">
                                        <span class="custom-border-purple p-2 text-center text-white" v-on:click="sendForgot">
                                                        <label class="ml-2 mr-2">Send Code</label></span>
                                        <br />
                                        <label class="font-color-928AFD mt-4">Back to Login</label>
                                    </div>
                                </CCard>
                            </CCol>
                        </div>
    
    
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
       
    
    
    </div>
</template>


<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            userEmail: ""





        };
    },


    methods: {
        sendForgot() {
            this.ErrorLogin = false;

            const formData = new FormData();

            if (this.userEmail === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("userEmail", this.userEmail);

                this.$API
                    .post(this.$ForgotPassword, formData)
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                        if (response.status == 200) {

                            if (response.status !== 400) {


                               this.$router.push("Verifypassword?email=" + this.userEmail);

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.ErrorLogin = true;
                            }
                        } else {
                            this.Loading = false;
                            this.ErrorLogin = true;
                            this.Message = response.data.message;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
            }
        },



    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>